import * as React from 'react';
import { Box, Flex } from '../../CommonUI/Layout';
import { Select, Label, Badge, NotificationAlert, NotificationType } from '../../CommonUI';
import Button from '../../CommonUI/Control/Button';
import { Text } from 'ilenia';
import { PastOrdersPeriod, Settings,  } from '../../Model';
import { postPastOrdersInfo } from '../../Api/ecommscriptClient';
import { css, StyleSheet } from 'aphrodite';
import { ProductReviewsToggle } from '../../Components';
import { InfoIcon } from '../../Components/Common/InfoIcon';
import * as actions from '../../Actions/PastOrders/index';
import { connect } from 'react-redux';

interface InitialSyncProps {
    source: string;
    totalOrders: number | undefined;
    onSync: (period: PastOrdersPeriod) => void;
    onShowTotalOrders: (period: PastOrdersPeriod) => void;
    tierName: string;
    integrationKey: string;
    onLoggedInChange: (toggle: boolean) => void;
    onConsentChange: (toggle: boolean) => void;
    onToggleSettingsSave: (value: boolean) => void;
    onSettingsSave: () => void;
    onProductReviewsSettingChange: (selector: Settings) => void;
    settings: Settings;
    fetchPastOrdersSettings: () => void;
    isProductReviewsEnabled: boolean;
}

interface InitialSyncState {
    period: PastOrdersPeriod;
    productReviewsEnabled: any;
}

class InitialSync extends React.Component<InitialSyncProps, InitialSyncState> {
    constructor(props: InitialSyncProps) {
        super(props);
        props.fetchPastOrdersSettings();
        this.state = { period: PastOrdersPeriod['1 week'], productReviewsEnabled: undefined };
        this.onPeriodChange = this.onPeriodChange.bind(this);
        this.onClick = this.onClick.bind(this);
        this.toggleChanged = this.toggleChanged.bind(this);
    }

    public componentDidMount() {
        this.props.onShowTotalOrders(this.state.period);
    }

    public periodTextName(period: PastOrdersPeriod) {
        return Object.keys(PastOrdersPeriod).find((k) => PastOrdersPeriod[k] === period);
    }

    public onPeriodChange(id: string, value: PastOrdersPeriod) {
        const period = PastOrdersPeriod[value];
        this.props.onShowTotalOrders(period);
        this.setState({ period });
    }

    public onClick() {
        const { integrationKey, totalOrders, source } = this.props;

        if (totalOrders !== undefined) {
            const payload = {
                source,
                totalOrders,
            };
            postPastOrdersInfo(integrationKey, JSON.stringify(payload));
        }
        this.props.onSync(this.state.period);
    }

    public toggleChanged(value: boolean) {
      if (value) {
          NotificationAlert.alert(NotificationType.Success, 'Notifications.productReviewsEnabled');
      }
      this.setState({productReviewsEnabled: value});
    }

    public render() {
        const { source, totalOrders, tierName, onLoggedInChange, onSettingsSave, onConsentChange, onToggleSettingsSave, settings } = this.props;
        const { period } = this.state;
        return (
            <Box>
                <Flex alignItems={'left'} flexDirection={'column'} style={{maxWidth: '503px'}}>
                    <Box ml={20} mb={10} >
                        <Label label="pastOrders.pastOrdersTitle" />
                        <Text id="pastOrders.initialPastOrdersSelectDescription" />
                    </Box>
                    <Box className={css(styles.infoBoxContainer)}>
                      <p className={css(styles.iconWrapper)}>
                        <InfoIcon />
                      </p>
                      <p className={css(styles.textWrapper)}>
                        <Text id="enhancedPastOrders.bannerBox"/>
                      </p>
                    </Box>
                    <p className={css(styles.badge)}>
                      <Badge appearance={'success'}>
                        <Text id="enhancedPastOrders.reviewsOn"/>
                      </Badge>
                      { this.state.productReviewsEnabled ?? this.props.isProductReviewsEnabled ?
                        <Badge appearance={'success'}>
                          <Text id="enhancedPastOrders.productReviewsOn"/>
                        </Badge>
                      :
                        <Badge appearance={'default'}>
                          <Text id="enhancedPastOrders.productReviewsOff"/>
                        </Badge>
                      }
                      <ProductReviewsToggle
                        integrationKey={settings.general!.key!}
                        source={'Shopify'}
                        tierName={tierName}
                        onLoggedInChange={onLoggedInChange}
                        onSettingsSave={onSettingsSave}
                        toggleChanged={this.toggleChanged}
                        sku={settings.skuSelector!}
                        onProductReviewsSettingChange={this.props.onProductReviewsSettingChange}
                        productIdentificationOptions={settings.productIdentificationOptions}
                        onConsentChange={onConsentChange}
                        onToggleSettingsSave={onToggleSettingsSave}
                        appearance={'subtle'}
                        mt={1}
                        pl={0}
                      />
                    </p>
                    <Flex
                        flexDirection={'row'}
                        alignItems={'flex-end'}
                        justifyContent={'flex-start'}
                    >
                        <Select
                            id="position"
                            label="pastOrders.pastOrder"
                            localize={true}
                            value={this.periodTextName(period)}
                            onChangeEvent={this.onPeriodChange}
                            data={Object.keys(PastOrdersPeriod)}
                        />
                        { totalOrders !== undefined ?
                            <Box mb={12}>
                                <span style={{ color: '#00b67a' }}>{totalOrders}</span> <Text id="pastOrders.totalWillBeSynced"/>
                            </Box> : null
                        }
                    </Flex>
                    <Box ml={20} >
                      <Text id="pastOrders.note" />
                    </Box>
                    <Box>
                        <Flex flexDirection={'row'}>
                            <Button
                                width={'unset'}
                                onClick={this.onClick}
                                track={{
                                    placement: 'Bottom left corner',
                                    action: 'Sync past orders clicked',
                                    name: 'sync-past-orders-button',
                                    value: this.periodTextName(period),
                                    source,
                                    tierName,
                                }}
                            >
                                <Text id="pastOrders.syncPastOrders"/>
                            </Button>
                        </Flex>
                    </Box>
                </Flex>
            </Box>
        );
    }
}

const mapStateToProps = (state: any) => ({
  isProductReviewsEnabled: state.PastOrders.productReviewsEnabled
});

const mapDispatchToProps = (dispatch: any) => ({
  fetchPastOrdersSettings: () => dispatch(actions.fetchPastOrdersSettings()),
});

export default connect(mapStateToProps, mapDispatchToProps)(InitialSync);

const styles = StyleSheet.create({
  badge: {
    marginTop: '24px',
    marginBottom: '14px',
    display: 'inline-flex',
    columnGap: '24px',
    marginLeft: '20px',
  },
  infoBoxContainer: {
    maxWidth: '503px',
    display: 'flex',
    padding: '12px',
    marginTop: '16px',
    background: '#F3F4F5',
    marginLeft: '20px',
  },
  iconWrapper: {
    flex: '0 0 auto',
    marginLeft: '2.5px',
    marginTop: '2.5px',
    marginRight: '10.5px',
  },
  textWrapper: {
    margin: '0px',
    flex: 1,
    fontSize: '14px',
    lineHeight: '24px',
    letterSpacing: '0.3px'
  },
});



// WEBPACK FOOTER //
// ./src/Components/PastOrders/InitialSync.tsx